import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '../components/LanguageSelector';
import { FeedbackForm } from '../components/FeedbackForm';
import { SuccessPage } from '../components/SuccessPage';

// Opened inside the iOS / Android / HarmonyOS app (they always pass ?platform=). The app's own
// navigation bar already titles the page and pins the language, so the web chrome gets out of the way.
function isEmbeddedInApp(): boolean {
  const platform = new URLSearchParams(window.location.search).get('platform');
  return platform === 'ios' || platform === 'android' || platform === 'harmony';
}

export function FeedbackPage() {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [refCode, setRefCode] = useState('');
  const embedded = isEmbeddedInApp();

  const handleSuccess = (code: string) => {
    setRefCode(code);
    setSubmitted(true);
  };

  const handleReset = () => {
    setSubmitted(false);
    setRefCode('');
  };

  return (
    <div className={embedded ? 'container container--embedded' : 'container'}>
      {!embedded && <LanguageSelector />}

      <div className="card">
        {embedded ? (
          <p className="subtitle subtitle--embedded">{t('app.subtitle')}</p>
        ) : (
          <div className="header">
            <img src="/logo.png" alt="FUJISTYLE" className="app-logo" />
            <h1 className="logo">FUJISTYLE</h1>
            <p className="subtitle">{t('app.subtitle')}</p>
          </div>
        )}

        {submitted ? (
          <SuccessPage refCode={refCode} onReset={handleReset} />
        ) : (
          <FeedbackForm onSuccess={handleSuccess} />
        )}
      </div>
    </div>
  );
}
